import { render, staticRenderFns } from "./CommitteeCard.vue?vue&type=template&id=46db774f&"
import script from "./CommitteeCard.vue?vue&type=script&lang=js&"
export * from "./CommitteeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports